import { DynamicIcon } from 'phosphor-icons/react';
import { c } from '../../../utils/tailwind-merge';

type CategorySelectorProps = {
  categories: Category[];
};

type Category = {
  title: string;
  value: string;
  icon: string;
  url: string;
  variant?: 'default' | 'sale';
};

const CategoryItem = ({ value, url, icon, variant = 'default' }: Category) => {
  return (
    <li>
      <a
        href={url}
        className={c(
          'group flex items-center justify-center gap-2 rounded-md border px-2 py-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-focus',
          variant === 'default'
            ? 'border-line-medium text-content-muted'
            : 'border-danger text-danger'
        )}
      >
        <DynamicIcon
          iconName={icon}
          size={20}
          className={c(
            'transition-colors duration-300 ease-in-out',
            variant === 'default' && 'group-hover:text-link'
          )}
        />
        <div
          className={c(
            'text-sm leading-5 tracking-[-0.028px] transition-colors duration-300 ease-in-out',
            variant === 'default' && 'group-hover:text-content'
          )}
        >
          {value}
        </div>
      </a>
    </li>
  );
};

export const CategorySelector = ({ categories }: CategorySelectorProps) => {
  return (
    <div className="container">
      <ul className="flex flex-wrap gap-3">
        {categories.map((category) => (
          <CategoryItem key={category.value} {...category} />
        ))}
      </ul>
    </div>
  );
};
